<template>
  <div class="transcript-container">
    <div class="transcript-header">
      <h3>Audio Transcript</h3>
    </div>
    <div class="transcript">
      {{ getTranscript() }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Transcript',
  props: {
    transcript: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getTranscript() {
      return this.transcript.filter(t => t && t.toString().trim().length > 0).join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.transcript-container {
  background-color: #f9f9f9;
  border-left: 3px solid lighten($colony-primary, 42%);
  margin-top: 8px;
  margin-bottom: -13px;
  padding: 0;
  overflow: hidden;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.transcript-header {
  padding: 8px 12px;
  background-color: #f0f0f0;

  h3 {
    margin: 0;
    font-size: 0.8em;
    color: #90949c;
    font-weight: 600;
  }
}

.transcript {
  color: #90949c;
  font-size: 0.8em;
  padding: 8px 12px;
  text-align: left;
  line-height: 1.4;
}
</style>


// WEBPACK FOOTER //
// AudioTranscript.vue?215c2db4